import { z } from 'zod/v4';

export const RelationshipTypesListSortColumns = [
  'name',
  'createdAt',
  'updatedAt',
] as const;

export type RelationshipTypesListSortColumn =
  (typeof RelationshipTypesListSortColumns)[number];

const sortColumns = RelationshipTypesListSortColumns.join('|');

// One or more comma-separated `<column>:<ASC|DESC>` terms, e.g.
// `name:DESC,createdAt:ASC` — the same grammar the legacy route accepted.
const sortPattern = new RegExp(
  `^(${sortColumns}):(ASC|DESC)(,(${sortColumns}):(ASC|DESC))*$`,
);

export const RelationshipTypesListQuerySchema = z.object({
  page: z.coerce.number().int().min(0).default(0),
  count: z.coerce.number().int().min(0).max(500).default(15),
  sort: z.string().regex(sortPattern).optional(),
  // JSON object; only `name` is honoured (case-insensitive substring match).
  filter: z.string().max(512).optional(),
});

export type RelationshipTypesListQuery = z.infer<
  typeof RelationshipTypesListQuerySchema
>;

export const RelationshipTypeRowSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export type RelationshipTypeRow = z.infer<typeof RelationshipTypeRowSchema>;

// Same `{ data, meta }` envelope `reply.paginate` produces, so the existing
// frontend consumers keep reading `response.data` / `response.meta` unchanged.
export const RelationshipTypesListResponseSchema = z.object({
  data: z.array(RelationshipTypeRowSchema),
  meta: z.object({
    count: z.number(),
    page: z.number(),
    pageSize: z.number(),
    totalCount: z.number(),
  }),
});

export type RelationshipTypesListResponse = z.infer<
  typeof RelationshipTypesListResponseSchema
>;
